import React, { Suspense, lazy } from 'react';
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LocaleProvider } from "@/contexts/LocaleContext";
import ErrorBoundary from "@/components/ErrorBoundary";

const BonnotAI = lazy(() => import("@/components/BonnotAI"));
const AdminPage = lazy(() => import("@/components/AdminPage"));

function LoadingFallback() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
  );
}

function App() {
  const isAdmin = window.location.pathname.startsWith('/admin');

  return (
    <ErrorBoundary>
      <AuthProvider>
        <LocaleProvider>
          <div className="min-h-screen bg-background">
            <Suspense fallback={<LoadingFallback />}>
              {isAdmin ? <AdminPage /> : <BonnotAI />}
            </Suspense>
            <Toaster position="bottom-right" richColors />
          </div>
        </LocaleProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
